import { useState } from "react"
import { AppSpan, AppText, CustomContainer, FlexRow } from "src/style"
import LocationIcon from 'src/assets/svg/address-location-icon'
import TimeIcon from 'src/assets/svg/address-time-icon'
import LastLoginIcon from 'src/assets/svg/address-last_login-icon'
import AddressMap from 'src/assets/svg/address-map.svg'
import { addressData } from "src/utils/tableLayout"
import { Address, LocationData } from "src/model"
import helpers from "src/utils/helpers"

export const AddressMapView: React.FC<any> = ({locations}) => {
    const [selectedAddress, setSelecetedAddress] = useState<LocationData|null>(null)

    return (
        <CustomContainer topMargin="4">
            <FlexRow
                gap='1.5'
                topMargin='2'
                alignItems="stretch"
                justifyContent='space-between'
                className='dashboard-charts-container'
            >
                <CustomContainer 
                    width='37' sizeUnit='%'
                    className='dashboard-chart-wrapper'
                >
                    {
                        locations?.map((item: LocationData, index: number) => {
                            return (
                                <CustomContainer
                                    shadow={selectedAddress?.id === item.id ? '0px 4px 10px 0px #0000001A' : 'none'}
                                    minHeight='16.5'
                                    radius="0.2"
                                    bgColor="#ffffff"
                                    borderColor={selectedAddress?.id === item.id ? '#5627FF' : '#E7EBEE'}
                                    padding='1.5'
                                    bottomMargin="0.7"
                                    key={index}
                                    onClick={() => setSelecetedAddress(item)}
                                >
                                    <FlexRow 
                                        width="auto" sizeUnit="" bottomMargin="2"
                                        gap="1.5" alignItems="flex-start"
                                    >
                                        <LocationIcon isSelected={selectedAddress?.id === item.id}  />
                                        <CustomContainer width="auto" sizeUnit="">
                                            <AppSpan color="#1D1D1D">Geo Location</AppSpan>
                                            <AppText>{item.address}</AppText>
                                        </CustomContainer>
                                    </FlexRow>
                                    <FlexRow 
                                        justifyContent="space-between" wrap="wrap"
                                        alignItems="flex-start" gap="2"
                                    >
                                        <FlexRow 
                                            width="auto" sizeUnit=""
                                            gap="1.5" alignItems="flex-start"
                                        >
                                            <TimeIcon isSelected={selectedAddress?.id === item.id}  />
                                            <CustomContainer width="auto" sizeUnit="">
                                                <AppSpan color="#1D1D1D">Time Logged</AppSpan>
                                                <AppText>{typeof(item.createdOnDate) === 'string' ? helpers.splitDateTime(item.createdOnDate).date : 'Unavailable'}</AppText>
                                            </CustomContainer>
                                        </FlexRow>
                                        <FlexRow 
                                            width="auto" sizeUnit=""
                                            gap="1.5" alignItems="flex-start"
                                        >
                                            <LastLoginIcon isSelected={selectedAddress?.id === item.id}  />
                                            <CustomContainer width="auto" sizeUnit="">
                                                <AppSpan color="#1D1D1D">Last Login</AppSpan>
                                                <AppText>Unavailable</AppText>
                                            </CustomContainer>
                                        </FlexRow>
                                    </FlexRow>
                                </CustomContainer>
                            )
                        })
                    }
                </CustomContainer>

                <CustomContainer 
                    minHeight='61.9'
                    radius='0.8'
                    shadow='0px 10px 50px 0px #0000000D'
                    bgColor='#ffffff'
                    borderColor='#FAFAFA'
                    width='62' sizeUnit='%' 
                    className='dashboard-chart-wrapper'
                >
                    <img 
                        src={AddressMap} 
                        className='img-child' 
                        style={{objectFit: 'cover'}}
                    />
                </CustomContainer>
            </FlexRow>
        </CustomContainer>
    )
}